import React, { useEffect, useState } from "react";
import { Modal, Divider, Button } from "antd";
import styled from "@emotion/styled";
import CloseIcon from "@mui/icons-material/Close";

// quelld-frontend\src\Components\Modals\Dashboard\FilterModalWithoutColor.jsx
// import eventicon from "../../../Assets/calender/Event-icon.png";
import taskicon from "../../../Assets/calender/Task-icon.png";
import eventicon from "../../../Assets/calender/Event-icon.png";

const FilterModal = ({
  isFilterModalOpen,
  closeFilterModal,
  applyFilters,
  initialPriority = null,
  initialStatus = null,
}) => {
  const [typeFilter, setTypeFilter] = useState([]);
  const [priorityFilter, setPriorityFilter] = useState(initialPriority);
  const [statusFilter, setStatusFilter] = useState(initialStatus);

  const handleApply = () => {
    applyFilters({
      types: typeFilter,
      priority: priorityFilter,
      status: statusFilter,
    });
    closeFilterModal();
  };

  useEffect(() => {
    // console.log("______filter", {
    //   types: typeFilter,
    //   priority: priorityFilter,
    //   status: statusFilter,
    // });
  }, [typeFilter, priorityFilter, statusFilter]);

  const handleReset = () => {
    setTypeFilter([]);
    setPriorityFilter(null);
    setStatusFilter(null);
  };

  return (
    <Modal
      open={isFilterModalOpen}
      onCancel={closeFilterModal}
      footer={null}
      closable={false}
      centered
      width={450}
      bodyStyle={{ padding: 0 }}
    >
      <StyledModalWrapper>
        <OutsideCloseButton onClick={closeFilterModal}>
          <CloseIcon fontSize="medium" />
        </OutsideCloseButton>
        <ModalContent>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <SectionTitle style={{ marginBottom: 0 }}>Filters</SectionTitle>
            <CancelButton onClick={handleReset}>Reset</CancelButton>
          </div>

          <FilterSection>
            <SectionSubtitle>Category</SectionSubtitle>
            <ButtonGroup>
              {["task", "event"].map((type) => (
                <PillButton
                  key={type}
                  selected={typeFilter.includes(type)}
                  onClick={() => setTypeFilter([type])}
                  style={{
                    padding: "4px 16px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {/* {type === "task" ? "🗒️ Task" : "🎉 Event"} */}
                  <span>
                    <img
                      src={type === "task" ? taskicon : eventicon}
                      alt={type === "task" ? "Task" : "Event"}
                      width={18}
                      style={{ marginRight: "6px" }}
                    />
                    <span style={{ marginBottom: "4px" }}>
                      {type === "task" ? "Task" : "Event"}
                    </span>
                  </span>
                </PillButton>
              ))}
            </ButtonGroup>
          </FilterSection>

          {/* <Divider style={{ margin: "16px 0" }} /> */}

          <FilterSection>
            <SectionSubtitle>Priority</SectionSubtitle>
            <ButtonGroup>
              {[
                { label: "No priority", value: null },
                { label: "Low", value: "Low" },
                { label: "Medium", value: "Medium" },
                { label: "High", value: "High" },
              ].map((option) => (
                <PillButton
                  key={option.label}
                  selected={priorityFilter === option.value}
                  onClick={() => setPriorityFilter(option.value)}
                >
                  {option.label}
                </PillButton>
              ))}
            </ButtonGroup>
          </FilterSection>

          {/* <Divider style={{ margin: "16px 0" }} /> */}

          <FilterSection>
            <SectionSubtitle>Status</SectionSubtitle>
            <ButtonGroup>
              {["Pending", "Completed", "Not Started"].map((status) => (
                <PillButton
                  key={status}
                  selected={statusFilter === status}
                  onClick={() => setStatusFilter(status)}
                >
                  {status}
                </PillButton>
              ))}
            </ButtonGroup>
          </FilterSection>

          <ActionButtons>
            <CancelButton onClick={handleApply}>Cancel</CancelButton>
            <ApplyButton onClick={handleApply}>Apply</ApplyButton>
          </ActionButtons>
        </ModalContent>
      </StyledModalWrapper>
    </Modal>
  );
};

export default FilterModal;

const StyledModalWrapper = styled.div`
  padding: 0px;
`;

const ModalContent = styled.div`
  position: relative;
`;

const OutsideCloseButton = styled.div`
  position: absolute;
  top: -28px;
  right: 0px;
  background: white;
  border-radius: 50%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1000;
`;

const SectionTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 24px;
`;

const SectionSubtitle = styled.h3`
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 12px;
`;

const FilterSection = styled.div`
  margin-bottom: 24px;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`;

const PillButton = styled.button`
  padding: 8px 16px;
  border-radius: 6px;
  border: 1.4px solid ${({ selected }) => (selected ? "#a259ff" : "#ccc")};
  background-color: ${({ selected }) => (selected ? "#FEF1FE" : "#fff")};
  color: ${({ selected }) => (selected ? "#9A4FE0" : "#000")};
  font-weight: ${({ selected }) => (selected ? "600" : "400")};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: #a259ff;
  }
`;

const ActionButtons = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 32px;
`;

const CancelButton = styled.button`
  padding: 10px 20px;
  border: 1px solid #d8b4fe;
  background-color: #f3e8ff;
  color: #a259ff;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
`;

const ApplyButton = styled.button`
  padding: 10px 20px;
  background-color: #a259ff;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
`;
